// extracted by mini-css-extract-plugin
export default {"psh":"PreSaleHero_psh__cfC0R","psh_subtitle":"PreSaleHero_psh_subtitle__YWlhp","psh_title":"PreSaleHero_psh_title__CLhE-","psh_desc":"PreSaleHero_psh_desc__167u4"};